import { apiClient } from './axios';

export interface WhatsAppTemplate {
  id: string;
  name: string;
  language: string;
  category: string;
  components: unknown;
  status: string;
  meta_template_id: string | null;
  rejected_reason: string | null;
  whatsapp_business_account_id: string;
  created_at: string;
  updated_at: string;
}

export interface TemplateButton {
  type: 'URL' | 'QUICK_REPLY' | 'PHONE_NUMBER';
  text: string;
  url?: string;
  example?: string[];
}

export interface TemplateComponent {
  type: 'HEADER' | 'BODY' | 'FOOTER' | 'BUTTONS';
  format?: 'TEXT' | 'IMAGE' | 'VIDEO' | 'DOCUMENT';
  text?: string;
  buttons?: TemplateButton[];
  example?: {
    body_text?: string[][];
    header_text?: string[];
    header_url?: string[];
  };
}

export interface CarouselCard {
  components: TemplateComponent[];
}

export interface CarouselComponent {
  type: 'CAROUSEL';
  cards: CarouselCard[];
}

export type AnyComponent = TemplateComponent | CarouselComponent;

export interface CreateWhatsAppTemplateDto {
  name: string;
  language: string;
  category: 'MARKETING' | 'UTILITY' | 'AUTHENTICATION';
  components: AnyComponent[];
}

export const whatsappTemplatesApi = {
  list: () => apiClient.get<WhatsAppTemplate[]>('/whatsapp/templates').then((r) => r.data),

  get: (id: string) =>
    apiClient.get<WhatsAppTemplate>(`/whatsapp/templates/${id}`).then((r) => r.data),

  create: (data: CreateWhatsAppTemplateDto) =>
    apiClient.post<WhatsAppTemplate>('/whatsapp/templates', data).then((r) => r.data),

  sync: () =>
    apiClient
      .post<{ count: number; synced_at: string }>('/whatsapp/templates/sync')
      .then((r) => r.data),

  delete: (id: string) => apiClient.delete(`/whatsapp/templates/${id}`).then((r) => r.data),
};
